import common from "./zh/common";

export default {
    common,
};
